// Haptic Feedback Utility
// Provides tactile feedback for mobile devices (iOS and Android)
// Enhances user experience with subtle vibrations

/**
 * Trigger haptic feedback on supported devices
 * @param {string} type - Type of feedback: 'light', 'medium', 'heavy', 'success', 'error', 'warning'
 */
export const triggerHaptic = (type = 'light') => {
    // Check if vibration API is supported
    if (!window.navigator || !window.navigator.vibrate) {
        return; // Silently fail on unsupported devices
    }

    const patterns = {
        light: [10],
        medium: [20],
        heavy: [30],
        success: [10, 50, 10],
        error: [50, 100, 50],
        warning: [30, 50, 30],
        selection: [5],
        impact: [15]
    };

    const pattern = patterns[type] || patterns.light;
    
    try {
        window.navigator.vibrate(pattern);
    } catch (error) {
        // Silently fail if vibration fails
        // Haptic feedback not available - handled silently
    }
};

/**
 * Trigger haptic feedback on button click
 * Wraps an onClick handler with haptic feedback
 * @param {function} onClick - Original onClick handler
 * @param {string} hapticType - Type of haptic feedback
 * @returns {function} Enhanced onClick handler
 */
export const withHaptic = (onClick, hapticType = 'light') => {
    return (event) => {
        triggerHaptic(hapticType);
        if (onClick) {
            onClick(event);
        }
    };
};

/**
 * Check if device supports haptic feedback
 * @returns {boolean}
 */
export const isHapticSupported = () => {
    return !!(window.navigator && window.navigator.vibrate);
};

export default triggerHaptic;

